import { useLayoutEffect } from "react";

/**
 * Remonte en haut de la fenêtre à chaque changement de route / fiche.
 * Nécessaire pour les prévisualisations SPA : React Router conserve sinon
 * le scrollY de la page précédente (ex. formulaire d'édition).
 *
 * Désactiver via `enabled` en mode embedded (canvas CMS) pour ne pas
 * scroller la page hôte.
 */
export function useScrollToTopOnNavigate(
  navigationKey: string | undefined,
  enabled = true,
): void {
  useLayoutEffect(() => {
    if (!enabled || navigationKey == null) return;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [navigationKey, enabled]);
}
